import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class GlobalSettingsService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;

  getGlobalSettings(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/setup").subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  saveGlobalSettings(data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "management/setup", data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }
}